"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0;\n  line-height: 1.5;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 500px;\n  max-width: 90%;\n  margin: ", " auto;\n  text-align: center;\n  ", " {\n    margin: ", " auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = exports.Empty = exports.EmptyMessage = void 0;

var react_1 = __importDefault(require("react"));

var responsive_1 = require("../responsive");

var styled_1 = require("../styled");

var theme_1 = require("../theme");

var typography_1 = require("../typography");

var AntIconWrapper_1 = require("./AntIconWrapper");

var Button_1 = require("./Button");

function EmptyMessage(_ref) {
  var children = _ref.children;
  return react_1.default.createElement(EmptyMessageContainer, {
    children: children
  });
}

exports.EmptyMessage = EmptyMessage;

function Icon(_ref2) {
  var children = _ref2.children,
      noWrapper = _ref2.noWrapper;
  var icon = noWrapper ? children : react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
    children: children
  });
  return react_1.default.createElement(IconContainer, {
    children: icon
  });
}

function Title(_ref3) {
  var children = _ref3.children;
  return react_1.default.createElement(typography_1.BodyLarge, {
    useDiv: true,
    style: {
      lineHeight: 1.5
    }
  }, children);
}

function Description(_ref4) {
  var children = _ref4.children;
  return react_1.default.createElement(DescriptionContainer, {
    color: '@text-color-secondary'
  }, children);
}

function Action(props) {
  var child = react_1.default.Children.toArray(props.children)[0];

  if (react_1.default.isValidElement(child)) {
    return react_1.default.createElement(ActionContainer, null, react_1.default.cloneElement(child, {
      type: 'link',
      size: 'large'
    }));
  } else {
    return react_1.default.createElement(ActionContainer, null, react_1.default.createElement(Button_1.Button, Object.assign({}, props, {
      type: 'link',
      size: 'large'
    })));
  }
}

EmptyMessage.Icon = Icon;
EmptyMessage.Title = Title;
EmptyMessage.Description = Description;
EmptyMessage.Action = Action;
var EmptyMessageContainer = (0, styled_1.styledContainer)(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-m');
}, responsive_1.media.lg, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-xl');
});
var IconContainer = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-xxl');
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@text-color-secondary');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-m');
});
var DescriptionContainer = (0, styled_1.styledContainer)(_templateObject3(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-s');
});
var ActionContainer = (0, styled_1.styledContainer)(_templateObject4(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-m');
});

function Empty(_ref5) {
  var description = _ref5.description,
      icon = _ref5.icon,
      title = _ref5.title,
      action = _ref5.action;
  return react_1.default.createElement(EmptyMessage, null, icon ? react_1.default.createElement(EmptyMessage.Icon, null, icon) : null, react_1.default.createElement(EmptyMessage.Title, null, title || description), title ? react_1.default.createElement(EmptyMessage.Description, null, description) : null, action ? react_1.default.createElement(EmptyMessage.Action, {
    onClick: action.onClick
  }, action.title) : null);
}

exports.Empty = Empty;

var web_1 = require("@thesisedu/web");

Object.defineProperty(exports, "NotFound", {
  enumerable: true,
  get: function get() {
    return web_1.NotFound;
  }
});